import { useState, useEffect, useCallback } from "react";
import {
  faCode,
  faEdit,
  faIndianRupeeSign,
  faRotateRight,
} from "@fortawesome/free-solid-svg-icons";
import JSONPretty from "react-json-pretty";
import { withAppHOC } from "../../hoc";
import PageHeading from "../../components/PageHeader/PageHeader";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import NoData from "../../components/NoData/NoData";
import StatusHighliter from "../../components/StatusHighliter/StatusHighliter";
import {
  MessageBox,
  CustomButton,
  Label,
  Fieldset,
  TextInput,
  Button,
  Form,
  ResetButton,
  CustomConfirmButton,
  UpdateButton,
  FormContainer,
  Dropdown,
} from "../../components/FormElements";
import { TableBuilder } from "../../components/TableElements";
import Modal from "../../components/Modal";
import {
  StyledFiltersContainer,
  StyledModalContainer,
  StyledBodyContainer,
  StyledHeading,
  StyledContent,
  StyledApiCallLogsContainer,
  StyledSpan,
} from "../../components/Styled";
import Pagination from "../../components/Pagination/Pagination";
import API from "../../api";
import { API_RESPONSE_TYPES, PERMISSION_TYPES } from "../../constants";
import {
  getSearchParams,
  formatCurrency,
  shouldRedirect,
  redirectToPageOne,
} from "../../utils";
import FiltersButton from "../../components/FiltersButton/FiltersButton";
import Accordination from "../../components/Accordination/Accordination";
import { Grid, GridItem } from "../../components/Grid";
import exportFromJSON from "export-from-json";
import OverlayLoader from "../../components/OverlayLoader/OverlayLoader";
import moment from "moment";

const PendingRechargeTransactionsList = (props) => {
  const [paginationData, setPaginationData] = useState({
    pageNumber: getSearchParams("pageNumber") || 1,
    recordsPerPage: getSearchParams("recordsPerPage") || 100,
  });
  const [totalRecords, setTotalRecords] = useState(0);
  const [isFiltering, setIsFiltering] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [showFilters, setShowFilters] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [users, setUsers] = useState([]);
  const [operators, setOperators] = useState([]);
  const [apis, setApis] = useState([]);
  const [circles, setCircles] = useState([]);
  const [fromDate, setFromDate] = useState(moment().subtract(1, "days").format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [buyersId, setBuyersId] = useState("");
  const [sellersId, setSellersId] = useState("");
  const [operatorsId, setOperatorsId] = useState("");
  const [apisId, setApisId] = useState("");
  const [circlesId, setCirclesId] = useState("");
  const [transactionsId, setTransactionsId] = useState("");
  const [rechargeNumber, setRechargeNumber] = useState("");
  const [status, setStatus] = useState("Pending");
  const [category, setCategory] = useState("");
  const [type, setType] = useState("");
  const [attempt, setAttempt] = useState("");
  const [firstSeller, setFirstSeller] = useState("");
  const [buyersApiTransactionsId, setBuyersApiTransactionsId] = useState("");
  const [modalData, setModalData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [modalType, setModalType] = useState("");
  const [modalTransactionsId, setModalTransactionsId] = useState("");
  const [apiTransactionsId, setApiTransactionsId] = useState("");
  const [apiOperatorsId, setApiOperatorsId] = useState("");

  const onClickShowFilters = () => {
    setShowFilters((showFilters) => !showFilters);
  };

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus("");
    setResponseMessage("");
  };

  const resetFilters = () => {
    setFromDate("");
    setToDate("");
    setBuyersId("");
    setSellersId("");
    setOperatorsId("");
    setApisId("");
    setCirclesId("");
    setTransactionsId("");
    setRechargeNumber("");
    setStatus("Pending");
    setCategory("");
    setType("");
    setAttempt("");
    setFirstSeller("");
    setBuyersApiTransactionsId("");
    readData();
  };

  const resetModalForm = () => {
    setModalTransactionsId("");
    setApiTransactionsId("");
    setApiOperatorsId("");
  };

  const readUsers = () => {
    API.get("/accounts-management/users").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setUsers(data);
      }
    });
  };

  const readOperators = () => {
    API.get("/recharge-configurations/operators").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setOperators(data);
      }
    });
  };

  const readApis = () => {
    API.get("/recharge-configurations/seller-apis").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setApis(data);
      }
    });
  };

  const readCircles = () => {
    API.get("/recharge-configurations/circles").then((response) => {
      const { status, data } = response.data;
      if (status === API_RESPONSE_TYPES.SUCCESS) {
        setCircles(data);
      }
    });
  };

  const readData = useCallback(
    (
      fromDate = "",
      toDate = "",
      buyersId = "",
      sellersId = "",
      operatorsId = "",
      apisId = "",
      circlesId = "",
      transactionsId = "",
      rechargeNumber = "",
      status = "",
      category = "",
      type = "",
      attempt = "",
      firstSeller = "",
      buyersApiTransactionsId = ""
    ) => {
      setIsLoading(true);
      setResponseStatus("");
      setResponseMessage("");
      API.get(
        `/transactions/pending?pageNumber=${paginationData.pageNumber}&recordsPerPage=${paginationData.recordsPerPage}&fromDate=${fromDate}&toDate=${toDate}&buyersId=${buyersId}&sellersId=${sellersId}&operatorsId=${operatorsId}&apisId=${apisId}&circlesId=${circlesId}&transactionsId=${transactionsId}&rechargeNumber=${rechargeNumber}&status=${status}&category=${category}&type=${type}&attempt=${attempt}&firstSeller=${firstSeller}&buyersApiTransactionsId=${buyersApiTransactionsId}`
      )
        .then((response) => {
          const { status, data, pageInfo } = response.data;
          if (shouldRedirect(data?.length, paginationData?.pageNumber)) {
            redirectToPageOne();
          } else {
            if (status === API_RESPONSE_TYPES.SUCCESS) {
              setTotalRecords(pageInfo.totalRecords);
            }
            setTransactions(data);
          }
        })
        .catch((error) => {
          setResponseStatus(API_RESPONSE_TYPES.FAILED);
          setResponseMessage(error.message);
        })
        .finally(() => {
          setIsLoading(false);
        });
    },
    [paginationData]
  );

  const readLogs = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/transactions/logs/${id}`)
      .then((response) => {
        const { status, data } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setModalData(data);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const toggleModal = (id) => {
    setShowModal(true);
    setModalType("LOGS");
    readLogs(id);
  };

  const refundTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.put(`/transactions/refund/${id}`)
      .then((response) => {
        const { status, message } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          reloadData();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const updateTransaction = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.put(`/transactions/update/${modalTransactionsId}`, {
      apiTransactionsId,
      apiOperatorsId,
    })
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          reloadData();
          setTimeout(() => {
            setShowModal(false);
            setModalTransactionsId("");
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const reloadTransaction = (id) => {
    setIsLoading(true);
    setResponseStatus("");
    setResponseMessage("");
    API.get(`/transactions/reload/${id}`)
      .then((response) => {
        const { status, message } = response.data;
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          reloadData();
        } else {
          setResponseStatus(status);
          setResponseMessage(message);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILURE);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
        setTimeout(() => {
          resetResponseData();
        }, 3000);
      });
  };

  const onClickExport = () => {
    exportFromJSON({
      data: transactions,
      fileName: "pending-transactions",
      exportType: exportFromJSON.types.csv,
    });
  };

  const reloadData = () => {
    readData(
      fromDate,
      toDate,
      buyersId,
      sellersId,
      operatorsId,
      apisId,
      circlesId,
      transactionsId,
      rechargeNumber,
      status,
      category,
      type,
      attempt,
      firstSeller,
      buyersApiTransactionsId
    );
  };

  const filterData = (e) => {
    e.preventDefault();
    setIsFiltering(true);
  };

  useEffect(() => {
    if (isFiltering) {
      setPaginationData((paginationData) => ({
        pageNumber: 1,
        recordsPerPage: paginationData.recordsPerPage,
      }));
      setIsFiltering((isFiltering) => !isFiltering);
    }
  }, [isFiltering]);

  useEffect(() => {
    readUsers();
    readOperators();
    readApis();
    readCircles();
  }, []);

  useEffect(() => {
    if (!isFiltering) {
      readData(
        fromDate,
        toDate,
        buyersId,
        sellersId,
        operatorsId,
        apisId,
        circlesId,
        transactionsId,
        rechargeNumber,
        status,
        category,
        type,
        attempt,
        firstSeller,
        buyersApiTransactionsId
      );
    }
  }, [paginationData, readData]);

  const { accountsPermissions } = props;
  const canTrack =
    accountsPermissions.includes(PERMISSION_TYPES.TRACK) || false;
  const canUpdate =
    accountsPermissions.includes(PERMISSION_TYPES.UPDATE) || false;
  const canReload =
    accountsPermissions.includes(PERMISSION_TYPES.RELOAD) || false;
  const canRefund =
    accountsPermissions.includes(PERMISSION_TYPES.REFUND) || false;

  const userOptions = [{ title: "-- SELECT USER --", value: "" }];
  if (users && users.length > 0) {
    users.forEach(({ id, fullName, mobileNumber }) =>
      userOptions.push({
        title: fullName,
        value: id,
        subTitle: mobileNumber,
      })
    );
  }

  const operatorOptions = [{ title: "-- SELECT OPERATOR --", value: "" }];
  if (operators && operators.length > 0) {
    operators.forEach(({ id, operatorName }) =>
      operatorOptions.push({
        title: operatorName,
        value: id,
      })
    );
  }

  const apiOptions = [{ title: "-- SELECT API --", value: "" }];
  if (apis && apis.length > 0) {
    apis.forEach(({ id, apiName }) =>
      apiOptions.push({
        title: apiName,
        value: id,
      })
    );
  }

  const circleOptions = [{ title: "-- SELECT CIRCLE --", value: "" }];
  if (circles && circles.length > 0) {
    circles.forEach(({ id, circleName }) =>
      circleOptions.push({
        title: circleName,
        value: id,
      })
    );
  }

  return (
    <>
      <PageHeading
        {...props}
        reloadData={reloadData}
        showExport={transactions.length > 0}
        onClickExport={onClickExport}
      />
      <FiltersButton onClick={onClickShowFilters} value={showFilters} />
      <StyledFiltersContainer className={showFilters ? "show" : ""}>
        <Form method="POST" action="#" onSubmit={filterData}>
          <Fieldset>
            <Label>Buyer</Label>
            <Dropdown
              placeholder="Buyer"
              value={buyersId}
              onChange={setBuyersId}
              options={userOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Seller</Label>
            <Dropdown
              placeholder="Seller"
              value={sellersId}
              onChange={setSellersId}
              options={userOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Operator</Label>
            <Dropdown
              placeholder="Operator"
              value={operatorsId}
              onChange={setOperatorsId}
              options={operatorOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>API</Label>
            <Dropdown
              placeholder="Operator"
              value={operatorsId}
              onChange={setOperatorsId}
              options={operatorOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Circle</Label>
            <Dropdown
              placeholder="Operator"
              value={operatorsId}
              onChange={setOperatorsId}
              options={operatorOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Label>Transactions Id</Label>
            <TextInput
              value={transactionsId}
              onChange={setTransactionsId}
              placeholder="Transactions Id"
              maxLength={1000}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Recharge Number</Label>
            <TextInput
              value={rechargeNumber}
              onChange={setRechargeNumber}
              placeholder="Recharge Number"
              maxLength={100}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Buyers Transaction Id</Label>
            <TextInput
              value={buyersApiTransactionsId}
              onChange={setBuyersApiTransactionsId}
              placeholder="Buyers Transaction Id"
              maxLength={100}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>From Date</Label>
            <TextInput
              type="date"
              value={fromDate}
              onChange={setFromDate}
              placeholder="From Date"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>To Date</Label>
            <TextInput
              type="date"
              value={toDate}
              onChange={setToDate}
              placeholder="To Date"
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>Attempt</Label>
            <Dropdown
              placeholder="Attempt"
              value={attempt}
              onChange={setAttempt}
              options={[
                { title: "-- SELECT ATTEMPT --", value: "" },
                { title: "1", value: "1" },
                { title: "2", value: "2" },
                { title: "3", value: "3" },
                { title: "4", value: "4" },
                { title: "5", value: "5" },
                { title: "6", value: "6" },
                { title: "7", value: "7" },
                { title: "8", value: "8" },
                { title: "9", value: "9" },
                { title: "10", value: "10" },
              ]}
              disabled={isLoading}
            />
          </Fieldset>
          <Fieldset>
            <Label>First Seller</Label>
            <Dropdown
              placeholder="First Seller"
              value={firstSeller}
              onChange={setFirstSeller}
              options={userOptions}
              disabled={isLoading}
              searchable
            />
          </Fieldset>
          <Fieldset>
            <Button disabled={isLoading} type="submit">
              Filter
            </Button>
            <ResetButton
              disabled={isLoading}
              type="button"
              onClick={resetFilters}
            >
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
      </StyledFiltersContainer>
      <LoadingSpinner
        isLoading={
          !showModal &&
          responseStatus === "" &&
          transactions?.length === 0 &&
          isLoading
        }
      />
      <NoData
        status={
          responseStatus !== API_RESPONSE_TYPES.FAILED &&
          !isLoading &&
          transactions?.length === 0
        }
        message={`No transactions found`}
      />
      {!showModal && (
        <MessageBox status={responseStatus} message={responseMessage} />
      )}
      {transactions?.length > 0 && (
        <>
          <TableBuilder
            isLoading={!showModal && transactions?.length !== 0 && isLoading}
            tableHeadings={[
              {
                title: "",
                dataSelector: "transactionsId",
                sticky: true,
                canSort: false,
                width: "100px",
                CellRenderer: (value, item) => (
                  <>
                    {canTrack && (
                      <>
                        <CustomButton
                          icon={faCode}
                          onClick={() => toggleModal(value)}
                          style={{ color: "orange" }}
                        />
                      </>
                    )}
                    {canUpdate &&
                      (item.rechargeStatus === "Success" ||
                        item.rechargeStatus === "Pending") && (
                        <CustomButton
                          icon={faEdit}
                          onClick={() => {
                            setModalTransactionsId(value);
                            setApiOperatorsId(item.rechargeOperatorsId);
                            setApiTransactionsId(item.sellersApiTransactionsId);
                            setModalType("UPDATE");
                            setShowModal(true);
                          }}
                          style={{ color: "#0095ff" }}
                        />
                      )}
                    {canReload && item.rechargeStatus !== "Failure" && (
                      <CustomButton
                        icon={faRotateRight}
                        onClick={() => reloadTransaction(value)}
                        style={{ color: "#333f7a" }}
                      />
                    )}
                    {canRefund &&
                      (item.rechargeStatus === "Success" ||
                        item.rechargeStatus === "Pending") && (
                        <CustomConfirmButton
                          icon={faIndianRupeeSign}
                          title="Refund"
                          message="Are you sure, you want to refund this transaction ?"
                          proceedButtonText="Refund"
                          cancelButtonText="Cancel"
                          onClick={() => refundTransaction(value)}
                          color="forestgreen"
                          hoverColor="#006200"
                        />
                      )}
                  </>
                ),
              },
              {
                title: "Date & Time",
                dataSelector: "createdOn",
                dataType: "string",
              },
              {
                title: "Transaction Id",
                dataSelector: "transactionsId",
                dataType: "string",
              },
              {
                title: "Buyer",
                dataSelector: "buyerName",
                dataType: "string",
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    <StyledSpan>{item.buyersMobileNumber}</StyledSpan>
                  </>
                ),
              },
              {
                title: "Seller",
                dataSelector: "sellersName",
                dataType: "string",
                CellRenderer: (value, item) => (
                  <>
                    {value}
                    <StyledSpan>{item.sellersMobileNumber}</StyledSpan>
                  </>
                ),
              },
              {
                title: "Account/Mobile",
                dataSelector: "rechargeNumber",
                dataType: "string",
              },
              {
                title: "Amount",
                dataSelector: "rechargeAmount",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "Operator",
                dataSelector: "operatorName",
                dataType: "string",
              },
              {
                title: "Circle",
                dataSelector: "circleName",
                dataType: "string",
                CellRenderer: (value) => value || "N/A",
              },
              {
                title: "Category",
                dataSelector: "category",
                dataType: "string",
                CellRenderer: (value) => value || "N/A",
              },
              // {
              //   title: "Type",
              //   dataSelector: "transactionType",
              //   dataType: "string",
              // },
              {
                title: "API",
                dataSelector: "sellersApisName",
                dataType: "string",
              },
              {
                title: "Status",
                dataSelector: "rechargeStatus",
                dataType: "string",
                align: "center",
                CellRenderer: (value) => (
                  <StatusHighliter
                    className={
                      value === "Success"
                        ? "green"
                        : value === "Failed"
                        ? "red"
                        : "yellow"
                    }
                  >
                    {value}
                  </StatusHighliter>
                ),
              },
              {
                title: "Time Since Pending",
                dataSelector: "timeSincePending",
                dataType: "string",
                CellRenderer: (value) => value || "N/A",
              },
              {
                title: "Operators Id",
                dataSelector: "rechargeOperatorsId",
                dataType: "string",
                CellRenderer: (value) => value || "N/A",
              },
              {
                title: "Buyer Debit Amount",
                dataSelector: "buyerDebitAmount",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "Seller Credit Amount",
                dataSelector: "sellerCreditAmount",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
              {
                title: "Profit",
                dataSelector: "adminProfit",
                dataType: "number",
                CellRenderer: (value) => formatCurrency(value),
              },
            ]}
            tableData={transactions}
          />
          <Pagination
            totalRecords={totalRecords}
            paginationData={paginationData}
            setPaginationData={setPaginationData}
          />
          <Modal
            modalStatus={showModal}
            setModalStatus={() => {
              resetResponseData();
              setShowModal(false);
              setModalData([]);
              setModalType("");
              setApiOperatorsId("");
              setApiTransactionsId("");
            }}
            hideCloseButton
          >
            <StyledModalContainer width={`1200px`}>
              {modalType === "UPDATE" ? (
                <>
                  <h3>Update Transaction</h3>
                  <FormContainer>
                    <Fieldset>
                      <StyledSpan style={{ fontSize: "16px", color: "red" }}>
                        Note: Upon update transaction status will be marked as
                        Success
                      </StyledSpan>
                    </Fieldset>
                    <Form method="POST" action="#" onSubmit={updateTransaction}>
                      <Fieldset>
                        <Label required>API Transactions ID</Label>
                        <TextInput
                          value={apiTransactionsId}
                          onChange={setApiTransactionsId}
                          placeholder="Please enter api transactions id"
                          disabled={isLoading === true}
                        />
                      </Fieldset>
                      <Fieldset>
                        <Label required>API Operators ID</Label>
                        <TextInput
                          value={apiOperatorsId}
                          onChange={setApiOperatorsId}
                          placeholder="Please enter api operators id"
                          disabled={isLoading === true}
                        />
                      </Fieldset>
                      {showModal && responseStatus !== "" && (
                        <Fieldset>
                          <MessageBox
                            status={responseStatus}
                            message={responseMessage}
                          />
                        </Fieldset>
                      )}
                      <Fieldset>
                        <UpdateButton
                          disabled={isLoading === true}
                          type="submit"
                          style={{ width: "auto" }}
                        >
                          Update
                        </UpdateButton>
                        <ResetButton
                          disabled={isLoading === true}
                          type="button"
                          onClick={resetModalForm}
                        >
                          Reset
                        </ResetButton>
                      </Fieldset>
                      <OverlayLoader showLoader={showModal && isLoading} />
                    </Form>
                  </FormContainer>
                </>
              ) : (
                <>
                  <h3>API Call Logs</h3>
                  <StyledApiCallLogsContainer>
                    <LoadingSpinner
                      isLoading={
                        responseStatus === "" &&
                        modalData?.length === 0 &&
                        isLoading
                      }
                    />
                    <NoData
                      status={
                        responseStatus !== API_RESPONSE_TYPES.FAILED &&
                        !isLoading &&
                        modalData?.length === 0
                      }
                      message={`No api logs found`}
                    />
                    <MessageBox
                      status={responseStatus}
                      message={responseMessage}
                    />
                    {modalData?.length > 0 &&
                      modalData.map(
                        (
                          {
                            requestType,
                            request,
                            requestOn,
                            requestBody,
                            response,
                            responseOn,
                          },
                          index
                        ) => (
                          <Accordination
                            key={index}
                            header={`${requestType}`}
                            autoExpanded={true}
                          >
                            <Grid columns={"calc(50% - 10px) calc(50% - 10px)"}>
                              <GridItem>
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Request{" "}
                                    {requestOn && `( ${requestOn} )`}
                                  </StyledHeading>
                                  <StyledContent>{request}</StyledContent>
                                </StyledBodyContainer>
                                {requestBody && (
                                  <StyledBodyContainer>
                                    <StyledHeading>
                                      API Request Body
                                    </StyledHeading>
                                    <StyledContent>{requestBody}</StyledContent>
                                  </StyledBodyContainer>
                                )}
                              </GridItem>
                              <GridItem>
                                <StyledBodyContainer>
                                  <StyledHeading>
                                    API Response{" "}
                                    {responseOn && `( ${responseOn} )`}
                                  </StyledHeading>
                                  <StyledContent>
                                    <JSONPretty
                                      id="json-pretty"
                                      data={response}
                                    ></JSONPretty>
                                  </StyledContent>
                                </StyledBodyContainer>
                              </GridItem>
                            </Grid>
                          </Accordination>
                        )
                      )}
                  </StyledApiCallLogsContainer>
                </>
              )}
            </StyledModalContainer>
          </Modal>
        </>
      )}
    </>
  );
};

export default withAppHOC(PendingRechargeTransactionsList);
